import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const { data } = await api.get('/public/settings');
                setSettings(data || {});
            } catch (e) {
                console.error('Failed to load settings', e);
                setSettings({});
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, loading, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    const ctx = useContext(SettingsContext);
    return ctx || { settings: {}, loading: false };
}
